import {
	GridColumnProps,
	GridHeaderCellProps,
} from "@progress/kendo-react-grid";
import { t } from "i18next";
import { FC } from "react";
import { GrideDateFormatter } from "ui/Date";
import { ColumnMenuCheckboxFilter } from "ui/grid/ColumnMenuFilter";
import CellPopover from "ui/grid/DescriptionCell";
import { NumericalCell } from "ui/grid/GridCommandCell";
import { CLASSNAME } from "utils/constant";

export const frozenSaleWeeklyGridColumn = (data: any[]): GridColumnProps[] => {
	return [
		{
			field: "vesselName",
			title: t("VesselName"),
			cells: { data: (props) => <CellPopover {...props} /> },
			width: "170px",
			columnMenu: (prop) => <ColumnMenuCheckboxFilter {...prop} data={data} />,
		},
		{
			field: "fishingGearText",
			title: t("FishingGear"),
			width: "110px",
			columnMenu: (prop) => <ColumnMenuCheckboxFilter {...prop} data={data} />,
		},
		{
			field: "species",
			title: t("Species"),
			width: "150px",
			columnMenu: (prop) => <ColumnMenuCheckboxFilter {...prop} data={data} />,
		},
		{
			field: "productText",
			title: t("Product"),
			cells: { data: (props) => <CellPopover {...props} /> },
			width: "320px",
			columnMenu: (prop) => <ColumnMenuCheckboxFilter {...prop} data={data} />,
		},
		{
			field: "netLiveWeightKg",
			title: t("Weight"),
			width: "100px",
			cells: {
				data: (props) => (
					<NumericalCell {...props} unit={"kg"} formatDecimal={2} />
				),
				headerCell: (props) => <NumericalHeader {...props} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "price",
			title: t("Price"),
			width: "90px",
			cells: {
				data: (props) => (
					<NumericalCell {...props} unit={"kr"} formatDecimal={2} />
				),
				headerCell: (props) => <NumericalHeader {...props} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "averageNetLiveWeightKg",
			title: t("AverageWeight"),
			width: "90px",
			cells: {
				data: (props) => (
					<NumericalCell
						{...props}
						unit={"kg"}
						formatDecimal={2}
						showZero={false}
					/>
				),
				headerCell: (props) => <NumericalHeader {...props} />,
			},
			headerClassName: CLASSNAME.TableNumeric,
			className: `${CLASSNAME.TableNumeric} no-border`,
		},
		{
			field: "msc",
			title: "msc",
			width: "50px",
		},
		//{
		//	field: "information",
		//	title: t("Information"),
		//	cells: { data: (props) => <CellPopover {...props} /> },
		//},
		{
			field: "buyerName",
			title: t("BuyerName"),
			cells: { data: (props) => <CellPopover {...props} /> },
		},
		{
			field: "salesDate",
			title: t("Date"),
			width: "110px",
			headerClassName: "no-border",
			cells: {
				data: (props) => (
					<GrideDateFormatter
						date={props.dataItem.salesDate}
						formatType={"dd.MM.yyyy"}
					/>
				),
			},
		},
		{
			field: "salesWeekDay",
			title: t("WeekDay"),
			width: "100px",
			columnMenu: (prop) => <ColumnMenuCheckboxFilter {...prop} data={data} />,
		},
		{
			field: "salesType",
			title: t("Type"),
			width: "100px",
			cells: { data: (props) => <CellPopover {...props} /> },
			columnMenu: (prop) => <ColumnMenuCheckboxFilter {...prop} data={data} />,
		},
	];
};

const NumericalHeader: FC<
	GridHeaderCellProps & { style?: React.CSSProperties } & any
> = (props) => {
	return (
		<th style={{ ...props.style, textAlign: "end", paddingRight: "10px" }}>
			{props.title}
		</th>
	);
};
